/**
 * @ngdoc controller
 * @name overviewController
 * @description Handles the logic for displaying the ecourse overview
 * @param $state
 * @param ecourse
 * @param OverlayFactory
 * @param Ecourses
 * @param Util
 * @constructor
 */
export default function overviewController($state, ecourse, OverlayFactory, Ecourses, Util) {
  'ngInject';
  this.ecourse = ecourse;

  this.play = () => {
    Ecourses.getCurrentVideo(this.ecourse.promoLivestreamId, true)
        .then(res => {
          const playerData = {
            playerPlaceholderDivId: "v1",
            videoManifestFilePath: res.promoLivestreamVideoUrl,
          }
          const player = bethelPlayer(playerData);
          this.videoOpen = true;
        })
  }

  this.pause = () => {
    jwplayer().remove();
  };

  this.login = () => {
    Util.scrollToTop();
    $state.go('app.login');
  };

  // course isn't bought and doesn't alow for buying
  if (!this.ecourse.userData && !this.ecourse.purchasable) {
    this.overlay = OverlayFactory.redirectOverLay();
  }

  if (this.ecourse.userData) {
    this.overlay = OverlayFactory.resumeCourseOverlay(this.ecourse);
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/overview/overview.controller.js
 **/